module.exports = __webpack_public_path__ + "static/media/RPNewyork-logo.d9881bda.png";